import styled from 'styled-components';

const StyledContainer = styled.div`
	position: absolute;
	top: -4px;
	left: -4px;
	width: 408px;
	height: 608px;
	background: linear-gradient(180deg, #949494 0%, #252525 100%);
	border-radius: 64px 64px 0 0;
`;

const StyledVolumeButton = styled.div<{ $top: number }>`
	position: absolute;
	top: ${({ $top }) => $top}px;
	left: -2px;
	width: 2px;
	height: 60px;
	background: #222222;
`;

const StyledPowerButton = styled.div`
	position: absolute;
	top: 210px;
	right: -2px;
	width: 2px;
	height: 90px;
	background: #000000;
`;

const StyledSeam = styled.div<{ $left: number }>`
	position: absolute;
	top: 100px;
	left: ${({ $left }) => $left}px;
	width: 4px;
	height: 2px;
	background: #000000;
	box-shadow: 0 1px 0 0 rgba(255, 255, 255, 0.25);
`;

export { StyledContainer, StyledPowerButton, StyledSeam, StyledVolumeButton };
